export enum SessionRowTestID {
  MemberProfileButton = 'SessionRowTestID.MemberProfileButton',
}
